import Form from 'react-bootstrap/Form';
import AppInput from '../atoms/AppInput';
import AppButton from '../atoms/AppButton';
import { IconTrash } from '../atoms/Icon';
import { MODALITIES } from '../api/ordersApi';
import { formatBRL } from '../utils/currency';
import { formatWhatsapp } from '../utils/phone';

function PdvCart({ form, onChange, items, onQuantity, onRemove, onSubmit, saving }) {
  const modalityConfig = MODALITIES.find((m) => m.value === form.modality);
  const total = items.reduce((sum, i) => sum + i.unitPrice * i.quantity, 0);
  const set = (patch) => onChange({ ...form, ...patch });

  return (
    <aside className="pdv-cart">
      <div className="pdv-cart-scroll">
        <div className="items-summary-title mb-2">Pedido</div>

        {items.length === 0 ? (
          <p className="items-summary-empty mb-3">
            Toque nos produtos ao lado para montar o pedido.
          </p>
        ) : (
          <div className="mb-3">
            {items.map((item) => (
              <div key={item.key} className="pdv-line">
                <div className="flex-grow-1" style={{ minWidth: 0 }}>
                  <div className="pdv-line-name">{item.label}</div>
                  {/* Adicionais entram no preço unitário, então precisam estar
                      visíveis — senão o valor da linha não se explica. */}
                  {item.addons?.length > 0 && (
                    <div className="pdv-line-addons">
                      {item.addons.map((a) => `+ ${a.name}`).join(' · ')}
                    </div>
                  )}
                  <div className="pdv-line-price">{formatBRL(item.unitPrice)} un.</div>
                </div>

                <div className="pdv-qty">
                  <button type="button" onClick={() => onQuantity(item.key, item.quantity - 1)} aria-label="Menos um">−</button>
                  <span>{item.quantity}</span>
                  <button type="button" onClick={() => onQuantity(item.key, item.quantity + 1)} aria-label="Mais um">+</button>
                </div>

                <div className="pdv-line-total">{formatBRL(item.unitPrice * item.quantity)}</div>

                <button
                  type="button"
                  className="action-btn icon-btn action-btn-danger"
                  onClick={() => onRemove(item.key)}
                  aria-label={`Remover ${item.label}`}
                >
                  <IconTrash size={14} />
                </button>
              </div>
            ))}
          </div>
        )}

        <Form.Group className="mb-3">
          <Form.Label>Tipo de pedido</Form.Label>
          <div className="d-flex gap-2 flex-wrap">
            {MODALITIES.map((m) => (
              <button
                key={m.value}
                type="button"
                onClick={() => set({ modality: m.value })}
                className={`modality-option${form.modality === m.value ? ' active' : ''}`}
              >
                {m.label}
              </button>
            ))}
          </div>
        </Form.Group>

        {modalityConfig?.needs === 'address' && (
          <AppInput
            label="Endereço de entrega"
            value={form.address}
            onChange={(e) => set({ address: e.target.value })}
            placeholder="Rua, número, complemento e bairro"
          />
        )}

        {modalityConfig?.needs === 'tableLabel' && (
          <AppInput
            label="Mesa ou comanda"
            value={form.tableLabel}
            onChange={(e) => set({ tableLabel: e.target.value })}
            placeholder="Ex: Mesa 5"
            autoCapitalize="words"
            autoCorrect="off"
            enterKeyHint="next"
          />
        )}

        <AppInput
          label="Cliente"
          value={form.customerName}
          onChange={(e) => set({ customerName: e.target.value })}
          placeholder="Nome de quem está pedindo"
          autoComplete="name"
          autoCapitalize="words"
          autoCorrect="off"
          enterKeyHint="next"
        />

        <AppInput
          label="Telefone (opcional)"
          type="tel"
          value={form.customerPhone}
          onChange={(e) => set({ customerPhone: formatWhatsapp(e.target.value) })}
          placeholder="(11) 99999-9999"
          autoComplete="tel-national"
          inputMode="numeric"
          enterKeyHint="next"
        />

        <Form.Group>
          <Form.Label>Observações (opcional)</Form.Label>
          <Form.Control
            as="textarea"
            rows={2}
            value={form.notes}
            onChange={(e) => set({ notes: e.target.value })}
            placeholder="Sem cebola, entregar na portaria..."
            autoCapitalize="sentences"
            enterKeyHint="done"
          />
        </Form.Group>
      </div>

      <div className="pdv-cart-foot">
        <div className="d-flex justify-content-between align-items-center mb-2">
          <span style={{ fontSize: 13, color: '#777' }}>
            {items.reduce((n, i) => n + i.quantity, 0)} {items.reduce((n, i) => n + i.quantity, 0) === 1 ? 'item' : 'itens'}
          </span>
          <span className="fw-bold" style={{ fontSize: 20, color: 'var(--color-neutral)' }}>
            {formatBRL(total)}
          </span>
        </div>
        <AppButton
          variant="primary"
          className="w-100"
          onClick={onSubmit}
          disabled={saving || items.length === 0}
        >
          {saving ? 'Enviando...' : 'Enviar pedido'}
        </AppButton>
      </div>
    </aside>
  );
}

export default PdvCart;
